<template>
  <zj-layout-container class="zj-resources-team-manage" v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:0.8rem 0px 0px 0px;margin-left: 20rem;z-index: 2;">
      <div class="zj-button-bar">
        <el-button size="mini" @click="onAdd">添 加</el-button>
        <el-button size="mini" @click="onbatchDel">删 除</el-button>
      </div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;margin-top: -3.5rem;">
    <div class="group-container">
      <div class="labelgroup">内部组织</div>
      <div class="group-bar">
        <el-table
          :data="tableData"
          ref="multipleTable"
          @selection-change="selectionChange"
          border
          style="width: 100%"
          height="100%"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="PersonName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="TitleName" label="职位" align="center"></el-table-column>
          <el-table-column prop="Sex" label="性别" :formatter="ConvertSex" align="center"></el-table-column>
          <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
          <el-table-column prop="PhoneNum" label="联系方式" align="center"></el-table-column>
          <el-table-column prop="OrgianiztionName" label="所属组织" align="center"></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-bar">
        <el-divider></el-divider>
      </div>
      <div class="labelgroup">外部组织</div>
      <div class="group-bar">
        <el-table
          :data="tableData2"
          ref="multipleTable2"
          @selection-change="selectionChange2"
          border
          style="width: 100%"
          height="100%"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="PersonName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="TitleName" label="职位" align="center"></el-table-column>
          <el-table-column prop="Sex" label="性别" :formatter="ConvertSex" align="center"></el-table-column>
          <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
          <el-table-column prop="PhoneNum" label="联系方式" align="center"></el-table-column>
          <el-table-column prop="OrgianiztionName" label="所属组织" align="center"></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "ZjAddrescueteamlist",
  componentName: "ZjAddrescueteamlist",
  controller: "EmergencyResource",
  action: "Addrescueteamlist",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      PersonName: "",
      tableData: [],
      selectData: null,
      tableData2: [],
      selectData2: null
    };
  },
  // 接受父组件传递的数据
  props: {
    resourceTypeId: String
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    searchinfo: function(obj) {
      this.search(obj);
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    selectionChange2(val) {
      // 将选中的数据存储起来
      this.selectData2 = val;
    },
    search(info) {
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.AddressbookApi()
        .GetPageContentByConditions(info)
        .then(r => {
          //console.log("1");
          r = r.data.Data;
          let dataList = [];
          let dataList2 = [];
          if (r.PageContents != null) {
            dataList = r.PageContents.filter(item => {
              return item.OrgianiztionTypeId.includes("内部");
            });
            dataList2 = r.PageContents.filter(item => {
              return item.OrgianiztionTypeId.includes("外部");
            });
          }
          this.tableData = dataList;
          this.tableData2 = dataList2;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    ConvertSex(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      if (data == "1") {
        return "男";
      }
      if (data == "2") {
        return "女";
      }
    },
    // 点击查询按钮
    onSearch() {
      let searchInfo = {
        ResourceTypeId: this.resourceTypeId,
        PageSize: 2000,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.search(searchInfo);
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        // name: 'mallList',
        query: {
          obj: row,
          type: "edit",
            ResourceTypeId:this.resourceTypeId
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        // name: 'mallList',
        query: {
          obj: row,
          type: "search",
            ResourceTypeId:this.resourceTypeId
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        // name: 'mallList',
        query: {
          obj: null,
          type: "edit",
          ResourceTypeId:this.resourceTypeId
        }
      });
    },
    //批量删除
    onbatchDel() {
      let selection = [];
      selection = selection.concat(this.selectData || []);
      selection = selection.concat(this.selectData2 || []);
      if (selection.length > 0) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable2.clearSelection();
            this.loading = true;
            this.loadingText = '删除中...';
            new MyApis.AddressbookApi()
              .DelItemList(selection)
              .then(r => {
                r = r.data.Data;
                if (r) {
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
                this.loading = false;
                this.logInfo.ActionName = "应急通讯录删除";
                this.logInfo.LogMessage = r ? "应急通讯录删除成功" : "应急通讯录删除失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急通讯录管理列表页面";
                this.addOperationLog();
                this.onSearch();
              })
              .catch(e => {
                console.error(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                this.loading = false;
              });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          new MyApis.AddressbookApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.logInfo.ActionName = "应急通讯录删除";
              this.logInfo.LogMessage = r ? "应急通讯录删除成功" : "应急通讯录删除失败";
              this.logInfo.ModuleName = "应急系统";
              this.logInfo.PageName = "应急通讯录管理列表页面";
              this.addOperationLog();
              this.onSearch();
            })
            .catch(e => {
              console.error(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>